// extracted by mini-css-extract-plugin
export default {"googleButtonWrap":"GoogleButton_googleButtonWrap__3vL0A","socialMediaButton":"GoogleButton_socialMediaButton__sC5-O","googleButtonOverlay":"GoogleButton_googleButtonOverlay__YIKUm"};